import { render, staticRenderFns } from "./CheckRecord.vue?vue&type=template&id=c80189f4&scoped=true&"
import script from "./CheckRecord.vue?vue&type=script&lang=js&"
export * from "./CheckRecord.vue?vue&type=script&lang=js&"
import style0 from "./CheckRecord.vue?vue&type=style&index=0&id=c80189f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80189f4",
  null
  
)

export default component.exports